<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class= "alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>             

          <b-form>
            <app-banco-cuenta
              label="Cuenta"
              :nombre="bancoCuentaNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>

            <b-form-group
              label="Fecha Emisión"
              label-for="fechaEmision"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaEmision" 
                v-model="fechaEmision" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Pago"
              label-for="fechaPago"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaPago" 
                v-model="fechaPago" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Numero"
              label-for="numero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model" 
                :state="importeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import { required, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'chequepropio/getField',
  mutationType: 'chequepropio/updateField',
});

export default {
  name: 'ABM',
  components: {
    appBancoCuenta: BancoCuenta,
  },
  props: {
    chequePropio: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      noValidar: true,
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      numeroValido: null,
      numeroInvalidoMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      labelCols: 2,
      alertCountDown: 15,
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'id',
      'bancoCuenta',
      'bancoCuentaNombre',
      'fechaEmision',
      'fechaPago',
      // 'fechaCreditoDebito',
      'numero',
      'importe',
    ])
  },  
  created() {
    this.showSpinner();
    this.$store.dispatch('chequepropio/inicializar')
      .then(() => this.getDatosAdicionales())
      .catch(() => this.showAlert('Se produjo un error al recuperar la información del cheque.', 'danger'))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('bancoscuentas/getList')
        .then(() => {
            vm.bancosCuentas = this.$store.getters['bancoscuentas/list']
            vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList']
          })
          .catch(() => this.showAlert('Se produjo un error al recuperar la información de cuentas bancarias.', 'danger'))
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal || !this.$v.importe.minValue) {
            this.importeInvalidoMsj = 'El importe del cheque debe ser un valor numérico positivo';
          }
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let bancoCuentaError = true;
      if (this.bancoCuenta) {
        if (this.bancoCuenta.id) {
          if (this.bancoCuenta.id != 0) {
            bancoCuentaError = false;
          }
        }
      }
      if (bancoCuentaError) {
        save = Boolean(false);
        this.bancoCuentaValida = false;
        this.bancoCuentaInvalidaMsj = 'Debe seleccionar la cuenta correspondiente.';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.$emit('chequePropioActualizado', 
            this.$store.getters['chequepropio/chequePropio']);
        }
      } 
    },
    goBack() {
      this.$emit('cancel');
    },
    bancoCuentaActualizada(bancoCuentaNombre) {
      this.bancoCuentaNombre = bancoCuentaNombre;

      let bancoCuenta = null;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }
      this.$store.dispatch('chequepropio/setBancoCuenta', bancoCuenta);

      this.bancoCuentaValida = null;
      this.bancoCuentaInvalidaMsj = '';
    },
  },
  watch: {
  },
  validations: {
    importe: {
      decimal,
      minValue: minValue(0.01),      
    },
    numero: {}
  },  
}
</script>

<style>
</style>
